import React from 'react';
import PropTypes from 'prop-types';
import { StyledBadge, StyledBadgeContent } from './styled';

const Badge = ({ children, invisible, size, border, offsetTop, offsetRight, red }) => {
    return (
        <StyledBadge>
            {children}
            <StyledBadgeContent
                invisible={invisible}
                size={size}
                border={border}
                offsetTop={offsetTop}
                offsetRight={offsetRight}
                red={red}
            />
        </StyledBadge>
    );
};

Badge.propTypes = {
    children: PropTypes.node,
    invisible: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'large']),
    border: PropTypes.bool,
    offsetTop: PropTypes.number,
    offsetRight: PropTypes.number
};

Badge.defaultProps = {
    invisible: false,
    size: 'small'
};

export default React.memo(Badge);